import { FastenCallbackMode } from "./fasten.callback.dtos";
export const getFastenApiMode = (isSandbox) => (isSandbox ? FastenCallbackMode.TEST : FastenCallbackMode.LIVE);
export const getFastenPublicId = (isSandbox, environment) => isSandbox ? environment.FASTEN_NONPRODUCTION_PUBLIC_ID : environment.FASTEN_PRODUCTION_PUBLIC_ID;
